/**
 * This variable is required to define the GRAPHQL_HOST and DRUPAL_LOGIN_URL
 * constants.
 */
export const DRUPAL_HOST = process.env.REACT_APP_DRUPAL_URL

if (!DRUPAL_HOST) {
  throw new Error(
    'You must set REACT_APP_DRUPAL_URL environment variable to run this application.',
  )
}
